import { SeoPage } from 'libs/shared-lib/interfaces';
export const NOT_FOUND_SEO_IT: SeoPage = {
    title: '404',
    description: 'La pagina richiesta non è stata trovata.',
    image: '',
    twitter: {
        card: 'summary',
        title: '404',
        description: 'La pagina richiesta non è stata trovata.',
    },
    og: {
        title: '404',
        description: 'La pagina richiesta non è stata trovata.',
    },
    robots: {
        noIndex: true,
        noFollow: true,
    },
};
